<template>
<div class="pr-3 pl-3 inner-admin-container">
  <b-form v-on:submit.prevent="save">
    <b-form-group id="select-layer-admin-group" horizontal label-size="sm" label="Select Layer:" label-for="select-layer-admin">
      <b-form-select id="select-layer-admin" size="sm" type="text" v-model="q" :options="layers" placeholder="None">
      </b-form-select>
    </b-form-group>
    <div id="selected-layer-admin-container" v-if="selectedLayer">
      <b-row>
        <b-col>
          <b-form-group label="Title" label-for="layer-title">
            <b-form-input id="layer-title" @change="commitKey('title')" v-model="selectedLayer['title']" required placeholder="Enter Title"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Type" label-for="layer-type">
            <b-form-select id="layer-type" @change="commitKey('data_type')" v-model="selectedLayer['data_type']" :options="['wms', 'wfs']" required placeholder="Select layer type"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Tags" label-for="layer-tags">
            <b-form-input id="layer-tags" @change="commitKey('tags')" v-model="selectedLayer['tags']" placeholder="Enter Tag"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Editable" label-for="layer-editable">
            <b-form-select id="layer-editable" @change="commitKey('editable')" v-model="selectedLayer['editable']" :options="[true, false]" required placeholder="Toggle editable"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Active state" label-for="layer-state">
            <b-form-select id="layer-state" @change="commitKey('state')" v-model="selectedLayer['state']" :options="['enabled', 'autoload', 'disabled']" placeholder="Toggle active state"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Transformable" label-for="layer-transform">
            <b-form-select id="layer-transform" @change="commitKey('transformable')" v-model="selectedLayer['transformable']" :options="[true, false]" placeholder="Toggle transformable state"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-alert id='user-reminder' v-if="state === 'UPDATED'" variant="warning" show>User may need to refresh to see changes</b-alert>
      <b-button type="submit" class="btn-xs" variant="primary" v-on:submit.prevent="save">Save</b-button>
    </div>

  </b-form>
</div>
</template>
<script>
export default {
  data () {
    return {
      workpack: {},
      changedKeys: [],
      q: null,
      selectedLayer: null,
      layers: [],
      state: 'DEFAULT'
    }
  },
  mounted () {
    this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
      if (node.title) {
        this.layers.push({
          text: node.title,
          value: node.id
        })
        this.layers.sort(function(a, b){
          if(a.text < b.text) return -1;
          if(a.text > b.text) return 1;
          return 0;
      })
      }
    })
  },
  methods: {
    commitKey (key) {
      if (this.changedKeys.indexOf(key) === -1) {
        this.changedKeys.push(key)
      }
    },
    save () {
      if (this.changedKeys.length > 0) {
        let p = {}
        this.changedKeys.forEach(k => p[k] = this.selectedLayer[k])
        this.$http.post('/api/admin-board/update-layer/', {
          id: this.selectedLayer['id'],
          data: p
        }).then(res => {
          this.state = "UPDATED"
          this.$notify({
            title: 'SUCCESS',
            text: 'Layer settings updated',
            type: 'success'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not update layer',
            type: 'error'
          })
        })
      } else {
        this.$notify({
          title: 'ERROR',
          text: 'No changes to save',
          type: 'error'
        })
      }
    }
  },
  watch: {
    q (l) {
      if (l) {
        this.changedKeys = []
        this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
          if (node.id === l) {
            this.selectedLayer = node
            this.state = 'DEFAULT'
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/admin/LayerSettings.vue